import Vue from 'vue'

let currentIdentityRequest = null;

export default {

    load(config) {
        return Vue.http.get('user/identity', config).then(currentIdentityResponse => {
            return currentIdentityResponse.body.data;
        });
    },

    getCurrent() {
        if (!currentIdentityRequest) {
            // Keep the request itself so concurrent callers share one fetch, but drop
            // it again on failure so a transient error is not cached for the session.
            currentIdentityRequest = this.load().catch(error => {
                currentIdentityRequest = null;
                throw error;
            });
        }

        return currentIdentityRequest;
    },

    hasBecome() {
        return !(null === localStorage.getItem('became'));
    },

}
